<template>
  <div class="chatbot-dialog">
    <el-dialog
        title="温馨提示"
        :visible="isDialogVisible"
        :before-close="handleCloseDialog"
        :show-close="false"
        :close-on-click-modal="false"
    >
      <p>尊敬的用户您好！请您先完成注册流程，再使用优行关爱小助手哦。</p>
      <span slot="footer" class="dialog-footer">
      <el-button class="dialog-btn" @click="handleCloseDialog">好 的</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AuthorityDialog',
  data() {
    // console.log(this)
    return {
      isDialogVisible: this.initialDialogVisible
    }
  },
  watch: {
    initialDialogVisible: function (val) {
      this.isDialogVisible = val
    }
  },
  methods: {
    handleCloseDialog: function () {
      this.isDialogVisible = false;
      this.$emit('sendDialogActionValue', this.isDialogVisible)
      window.history.back()

    }
  },
  props: {
    initialDialogVisible: Boolean,
  },
}
</script>

<style lang="scss">
.chatbot-dialog {
  text-align: center;

  .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 1px 3 pxrgba(0, 0, 0, .3);
    box-sizing: border-box;
    width: 70%;
  }

  .el-dialog__body {
    padding: 0px 30px;
    color: #606266;
    word-break: break-all;
  }

  .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: right;
    box-sizing: border-box;
    text-align: center;
  }

}

.chatbot-dialog p {
  line-height: 32px;
}

.chatbot-dialog p span {
  padding: 0px 5px;
}

.dialog-footer {
  margin-top: 15px;
  text-align: center !important;
}

.dialog-btn {
  background-color: #D72618;
  color: #fff;
  width: 90px;
  border-radius: 25px;
}

.red {
  color: #D72618;
}
</style>
